import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TProgram } from '@src/shared/types/program';

export function ProgramFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TProgram>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      {item.name}
    </FilterOptionItem>
  );
}
